import { CSSPixelValue } from "../types/CSSPixelValue";

export const coerceCssPixelValue = (value?: CSSPixelValue) => {
  if (value != null) return typeof value === "number" ? `${value}px` : value;
  return undefined;
};
